import { AlertTriangle, Clock } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "@/shared/components/ui/alert";
import { getClosingAlertInfo, formatRefMonth } from "@/shared/lib/closingDeadline";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const ClosingDeadlineAlert = () => {
  const info = getClosingAlertInfo();

  if (!info.show) return null;

  const isLastDay = info.daysLeft <= 1;
  const deadlineFormatted = format(info.deadline, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
  const monthLabel = formatRefMonth(info.referenceMonth);

  return (
    <div className="px-4 pt-2">
      <Alert
        className={`border-2 ${
          isLastDay
            ? "border-destructive bg-destructive/10 text-destructive"
            : "border-orange-400 bg-orange-50 text-orange-900 dark:bg-orange-950/30 dark:text-orange-200 dark:border-orange-600"
        }`}
      >
        <AlertTriangle className={`h-5 w-5 ${isLastDay ? "text-destructive" : "text-orange-500"}`} />
        <AlertTitle className="text-sm font-bold flex items-center gap-2">
          <Clock className="h-4 w-4" />
          Prazo de Fechamento — {monthLabel}
        </AlertTitle>
        <AlertDescription className="text-sm mt-1">
          {isLastDay ? (
            <>
              <strong>ÚLTIMO DIA!</strong> O prazo para aprovação dos lançamentos de{" "}
              <strong>{monthLabel}</strong> encerra <strong>hoje às 00h</strong> ({deadlineFormatted}).
              Após esse horário, lançamentos não aprovados serão desconsiderados no fechamento.
              {info.hoursLeft > 0 && (
                <span className="ml-1 font-semibold">
                  Restam aproximadamente {info.hoursLeft}h.
                </span>
              )}
            </>
          ) : (
            <>
              O prazo para aprovação dos lançamentos de <strong>{monthLabel}</strong> encerra em{" "}
              <strong>{info.daysLeft} dia{info.daysLeft > 1 ? "s" : ""}</strong> ({deadlineFormatted} às 00h).
              Após essa data, lançamentos não aprovados serão automaticamente desconsiderados no fechamento mensal.
            </>
          )}
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default ClosingDeadlineAlert;
